import { MedicalTechnologyEditDrawer } from '@app/icare/routes/_app/medizintechnik/-components/MedicalTechnologyEditDrawer'
import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { QueryBaseSchema } from '@pkg/api/query/QueryFilterSchema'
import { defineEntityConfig } from '@pkg/db/schema/EntityConfig'
import { ButtonLink } from '@pkg/ui/button'
import { LinkIndicatorIcon } from '@pkg/ui/common'
import { FormattedNameAndAddress } from '@pkg/ui/formattedContent/NameAndAddress'
import { FaLaptopMedical } from 'react-icons/fa6'
import { z } from 'zod'
import { MedicalTechnologySchema } from './schema/MedicalTechnology'

const label = t`Medizintechnik-Versorger`
export const MedicalTechnologyConfig = defineEntityConfig(() => ({
  schema: MedicalTechnologySchema,

  label,
  labelPlural: label,

  icon: FaLaptopMedical,

  route: {
    list: '/medizintechnik',
    edit: '/medizintechnik/$id',
    new: '/medizintechnik/new',
  },

  drawer: { modal: MedicalTechnologyEditDrawer },

  relationSelectionColumns: [
    {
      key: 'medicalTechnology.name',
      title: label,
      render: (_, row) => <FormattedNameAndAddress name={row.name} address={row.address ?? undefined} />,
    },
  ],

  indexColumns: [
    {
      key: 'medicalTechnology.name',
      title: label,
      fixed: 'start',
      render: (_, row) => (
        <FormattedNameAndAddress
          name={row.name}
          address={row.address ?? undefined}
          link={{ to: '/medizintechnik/$id', params: { id: row.id } }}
        />
      ),
    },
    {
      key: 'actions',
      title: <Trans>Aktionen</Trans>,
      sorter: false,
      fixed: 'end',
      render: (_, row) => (
        <ButtonLink to="/medizintechnik/$id" params={{ id: row.id }} size="small" shape="round">
          <Trans>Anzeigen</Trans>
          <LinkIndicatorIcon />
        </ButtonLink>
      ),
    },
  ],

  search: {
    filterSchema: QueryBaseSchema.extend({
      sortBy: z
        .enum([
          'medicalTechnology.name',
          'medicalTechnology.address.streetAddress',
          'medicalTechnology.address.zipCode',
          'medicalTechnology.address.city',
        ])
        .nullish(),
    }),
    sortableFields: ['name', 'createdAt'] as const,
    defaultSortBy: 'name',
    defaultSortOrder: 'asc',
  },

  format: {
    primary: val => val?.name,
  },
}))
